import { NgModule } from '@angular/core';
import { DashjsPlayerComponent } from './dashjs-player.component';

@NgModule({
  imports: [
  ],
  declarations: [DashjsPlayerComponent],
  exports: [DashjsPlayerComponent]
})
export class DashjsPlayerModule { }
